export const useActionRefreshFeed = () => {
  const { onPlay, complete } = useAbstractAction(
    'actionRefreshFeed',
    false,
    60000
  );

  onPlay(async () => {
    await useFeedLoadFromNetwork();
    complete(true);
  });
};
